/**
 * Whether the element is an editable text target (input, textarea, select or contenteditable),
 * i.e. a paste there is meant for the field and must not be handled globally.
 */
export const isEditableTextTarget = (target: EventTarget | null): boolean => {
  if (!(target instanceof HTMLElement)) return false
  if (target.isContentEditable) return true
  return (
    target instanceof HTMLInputElement ||
    target instanceof HTMLTextAreaElement ||
    target instanceof HTMLSelectElement
  )
}
